// Replaced with actual Health & Safety Committee Members (sourced from SafetyConcernsForm)
// Keeping the original shape (id, name, department) and adding email for richer usage.
export const committeeMembers = [
  { id: 1, name: 'Dennis Leis', department: 'Utilities', email: 'dennisl@diamondvalley.town', title: 'Utility Operator Co-Chair' },
  { id: 2, name: 'Iris Jackson', department: 'Finance', email: 'irisj@diamondvalley.town', title: 'Payroll & Benefits' },
  { id: 3, name: 'Wyatt Robinson', department: 'Parks & Facilities', email: 'wyattr@diamondvalley.town', title: 'Parks & Facilities' },
  { id: 4, name: 'Laurie Duquette', department: 'Recreation', email: 'lauried@diamondvalley.town', title: 'Arena Operator / Recreation Co-Chair' },
  { id: 5, name: 'Grant Spicer', department: 'Fire Department', email: 'grants@diamondvalley.town', title: 'Deputy Fire Chief (Station #3)' },
  { id: 6, name: 'Thresia Lawhead', department: 'Finance', email: 'thresial@diamondvalley.town', title: 'Finance Secretary / Accounts Payable Clerk' },
  { id: 7, name: 'Kim Hampton', department: 'Roads', email: 'kimh@diamondvalley.town', title: 'Roads' },
  { id: 8, name: 'Trevor Doublet', department: 'Fire Department', email: 'trevord@diamondvalley.town', title: 'Deputy Fire Chief (Station #2)' },
  { id: 9, name: 'Jim Olien', department: 'Fire Department', email: 'jimo@diamondvalley.town', title: 'Firefighter' },
  { id: 10, name: 'Doreen von Gradulewksi', department: 'Administration', email: 'doreen@davg.ca', title: 'Health and Safety Consultant' },
  { id: 1, name: 'Sharon Young', department: 'Administration', email: 'sy1951901albertaltd@shaw.ca', title: 'Auditor' }

];

export const previousMeetings = [
  // { id: 1, date: '2025-10-15', type: 'Regular Committee Meeting' },
  // { id: 2, date: '2025-09-20', type: 'Regular Committee Meeting' },
  //{ id: 3, date: '2025-08-18', type: 'Special Meeting - Incident Review' }
];

export const mockBusinessItems = [
  /**
  {
    id: 1,
    description: 'Inspection follow-up for building A',
    assignedTo: 'Mike Johnson',
    targetDate: '2025-11-01',
    completed: false,
    section: 'inspectionReports'
  },
  {
    id: 2,
    description: 'Review and update emergency evacuation procedures',
    assignedTo: 'Sarah Wilson',
    targetDate: '2025-11-15',
    completed: false,
    section: 'procedures'
  }
    */
];